export const DATA_ATTR = 'data-disable-on-input-value';
